import type { CanvasPaper } from "./types";

export const CANVAS_PAPERS: readonly CanvasPaper[] = [
  "plain",
  "grid",
  "twoLines",
  "threeLines",
];

export const isCanvasPaper = (value: unknown): value is CanvasPaper =>
  CANVAS_PAPERS.includes(value as CanvasPaper);
